import {
	getDesignMenu,
} from '../../api/nav.js'
import {
	getCategories,
	getDesignGetProducts
} from '../../api/all.js'
import {
	getDesignfooter
} from '../../api/footer.js'
import container from './basicContainer.js'
const compoentsConfig = [
	container,
	{
		groupName: "basic",
		level: 4,
		name: "搜索",
		compoentName: "wmSearch", // 组件名称 
		style: {}, // style 配置
		containerLayout: {
			justify: "start",
		},
		designName: "wmSearchTool",
		preStyle: {
			selfStyle: {
				iptType: "", // max / medium / small / mini 
				showBtn: true,
				showBtnIcon: true,
				showPreIcon: false,
				btnText: "",
				showInput: true,
				iptWidth: 300,
				btnFontColor: "#000000",
				bg: {
					position: "top left",
					bgtype: "color", // color gradient img
					bgGradient: "",
					bgImgWidth: 0,
					bgImgHeigth: 0,
					img: "",
					type: "no-repeat",
					color: "",
				},
				padding: [0, 0, 0, 0],
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				borderHover: {
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "",
					px: 0,
					color: "#fff"
				},
				icon: {
					iconName: "",
					show: true
				},
			},
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {}, // 数据配置
		icon: "searchPng"
	},
	
	
	
	
	
	{
		groupName: "basic",
		level: 4,
		name: "收藏",
		compoentName: "wmLike", // 组件名称 
		style: {}, // style 配置
		containerLayout: {
			justify: "start",
		},
		preStyle: {
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {
			num: 1
		}, // 数据配置

		icon: "starPng"
	},
	{
		groupName: "basic",
		level: 4,
		name: "个人中心",
		compoentName: "wmUser", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		preStyle: {
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {
			num: 1
		}, // 数据配置
		icon: "userPng"
	},
	{
		groupName: "basic",
		level: 4,
		name: "购物车",
		compoentName: "wmCartSidebar", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		designName: "wmSidebarTool",
		preStyle: {
			// 组件本身样式
			selfStyle: {
				iconNumShow:true,
				bg: {
					position: "top left",
					bgtype: "color", // color gradient img
					bgGradient: "",
					bgImgWidth: 0,
					bgImgHeigth: 0,
					img: "",
					type: "no-repeat",
					color: "",
				},
				padding: [0, 0, 0, 0],
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				icon: {
					iconName: "",
					show: true
				},
				data: {
					text: {
						list: [{
								language: "zh_cn",
								languageName: "中文",
								text: "购物车"
							},
							{
								language: "en",
								languageName: "英文",
								text: "My Cart"
							},
							{
								language: "zh_hk",
								languageName: "繁体中文",
								text: "cartsPage"
							},
							{
								language: "ja",
								languageName: "Japanese",
								text: "ショッピングカート"
							},
							{
								language: "ko",
								languageName: "간체 중문",
								text: "장바구니"
							},
							{
								language: "de",
								languageName: "Deutsch",
								text: "Warenkorb"
							},
							{
								language: "es",
								languageName: "Espanol",
								text: "Carrito"
							},
							{
								language: "fr",
								languageName: "French",
								text: "Panier"
							},
							{
								language: "id",
								languageName: "Indonesia",
								text: "Keranjang Belanja"
							},
							{
								language: "it",
								languageName: "Italiano",
								text: "Carrello"
							},
							{
								language: "ru",
								languageName: "Русский",
								text: "Корзина"
							}
						]
					}
				}, // 数据配置
			},
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {
			num: 1
		}, // 数据配置


		icon: "layoutPng"
	},
	{
		groupName: "basic",
		level: 4,
		name: "语言货币",
		compoentName: "wmLangMoney", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		preStyle: {
			fontIcon: {
				//图标是否展示
				currency: true,
				locale: true
			},
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {}, // 数据配置
		icon: "translatePng"
	},
	// {
	// 	groupName: "content",
	// 	isNeedData: true,
	// 	level: 4,
	// 	name: "图片",
	// 	compoentName: "wmImg", // 组件名称 
	// 	containerLayout: {
	// 		justify: "start",
	// 	},
	// 	style: {}, // style 配置
	// 	dataCompoent: ["selectPage"],
	// 	preStyle: {
	// 		// 组件样式实际上是容器样式
	// 		compontentStyle: {
	// 			width: 100,
	// 			height: 100,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: false,
	// 			needHW: true,
	// 			needFont: false
	// 		},
	// 		compontentStylePhone: {
	// 			width: 100,
	// 			height: 100,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: false,
	// 			needHW: true,
	// 			needFont: false
	// 		},
	// 		// 组件的样式
	// 	}, // 预编译style 配置
	// 	data: {
	// 		imgUrl: {
	// 			list: [{
	// 				url: "",
	// 			}]
	// 		},
	// 	}, // 数据配置
	// 	icon: "imagePng"

	// },


	{
		groupName: "content",
		isNeedData: true,
		level: 4,
		name: "图片",
		compoentName: "wmImgList", // 组件名称 
		designName: "wmImgListTool",
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		dataCompoent: ["selectPage"],
		preStyle: {
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 100,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: false,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 100,
				height: 100,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: false,
				needHW: false,
				needFont: false
			},
			// 组件的样式
		}, // 预编译style 配置

		layoutConfig: {
			img: {
				// mode:"cover",  // cover fill
				width: 250,
				height: 250,
				phoneWidth: 250,
				phoneHeight: 250,
				// 悬停边框
				hoverShadow: true,
				hoverShadowColor: null,
				pcNum: 1,
				phoneNum: 1,
				columnGap: 0,
				rowGap: 0,
				phoneColumnGap: 0,
				phoneRowGap: 0,
				padding: [0, 0, 0, 0],
				bg: {
					type: "2",
					// 纯色
					color: "",
					// 渐变
					gradientColor: ""
				},
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				borderHover: {
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				tit: {
					tit1Size: 14,
					tit1Family: "",
					tit1Color: "#000",
					tit1HoverColor: "",
					tit1InImg: true,
					tit1Position: "center", // left right top bottom
					tit1Padding: [0, 0, 0, 0],
					tit1Margin: [0, 0, 0, 0],
					tit1Bold: false,
					tit1Bg: {
						type: "1",
						// 纯色
						color: "",
						// 渐变
						gradientColor: ""
					},
					tit1Border: {
						borderRadius: [0, 0, 0, 0],
						borderSize: [0, 0, 0, 0],
						radius: 0,
						type: "solid",
						px: 0,
						color: "#fff"
					},
					tit2Bold: false,
					tit2Size: 14,
					tit2Family: "",
					tit2Color: "#000",
					tit2HoverColor: "",
					tit2InImg: true,
					tit2Position: "center", // left right top bottom
					tit2Padding: [0, 0, 0, 0],
					tit2Margin: [0, 0, 0, 0],
					tit2Bg: {
						type: "1",
						// 纯色
						color: "",
						// 渐变
						gradientColor: ""
					},
					tit2Border: {
						borderRadius: [0, 0, 0, 0],
						borderSize: [0, 0, 0, 0],
						radius: 0,
						type: "solid",
						px: 0,
						color: "#fff"
					},
				}
			}
		},

		data: {
			img: {
				list: [{
					url: "",
					link: {},
					tit1: "",
					tit2: "",

				}, ]
			},
		}, // 数据配置
		icon: "imagePng"
	},

	{
		groupName: "content",
		isNeedData: true,
		level: 4,
		name: "轮播",
		compoentName: "wmSwiper", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		dataCompoent: ["selectPage"],
		designName: "wmSwiperTool",
		preStyle: {
			selfStyle: {
				// 默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）、
				type: "slide", // 动效类型
				// 是否需要左右箭头
				isNeedArrow: true,
				// 是否需要指示器
				isNeedIndicator: true,
				// 指示器风格
				indicatorType: false,
				// 指示器颜色
				indicatorColor: "#55aaff",
				// 按钮颜色
				navBtnColor: "#55aaff",
				// 按钮颜色
				navBtnSize: 26,
				// 按钮风格
				navBtnType: false,
				// 是否循环
				isLoop: false,
				// 是否自动播放
				isAuto: true,
				// 轮播宽度
				width: 1000,
				height: 400,
				phoneWidth:100,
				phoneHeight:100,
				// 轮播高度
				padding: [0, 0, 0, 0],
				bg: {
					position: "top left",
					bgtype: "color", // color gradient img
					bgGradient: "",
					bgImgWidth: 0,
					bgImgHeigth: 0,
					img: "",
					type: "no-repeat",
					color: "",
				},

				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
			},
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 100,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: false,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 100,
				height: 100,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: false,
				needHW: false,
				needFont: false
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {
			list: [{
				type: "img", // video
				url: "", // 素材库里面选择
				control: false, // 是否需要播放控制器
				isAuto: true, // 是否自动播放视频
				firstImg: "", // 视频封面
				link: {},
				data: {}
			}]
		}, // 数据配置
		icon: "switchHorizontalPng",



	},


	// {
	// 	groupName: "content",
	// 	isNeedData: true,
	// 	level: 4,
	// 	name: "文本",
	// 	compoentName: "wmText", // 组件名称 
	// 	containerLayout: {
	// 		justify: "start",
	// 	},
	// 	style: {}, // style 配置
	// 	preStyle: {
	// 		// 组件样式实际上是容器样式
	// 		compontentStyle: {
	// 			width: 100,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			needHW: false,
	// 			needFont: true
	// 		},
	// 		compontentStylePhone: {
	// 			width: 100,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			needHW: false,
	// 			needFont: true
	// 		},
	// 		// 组件的样式
	// 	}, // 预编译style 配置
	// 	data: {
	// 		text: {
	// 			list: [{
	// 					language: "zh_cn",
	// 					languageName: "中文",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "en",
	// 					languageName: "英文",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "zh_hk",
	// 					languageName: "繁体中文",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "ja",
	// 					languageName: "Japanese",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "ko",
	// 					languageName: "간체 중문",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "de",
	// 					languageName: "Deutsch",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "es",
	// 					languageName: "Espanol",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "fr",
	// 					languageName: "French",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "id",
	// 					languageName: "Indonesia",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "it",
	// 					languageName: "Italiano",
	// 					text: ""
	// 				},
	// 				{
	// 					language: "ru",
	// 					languageName: "Русский",
	// 					text: ""
	// 				}
	// 			]
	// 		}
	// 	}, // 数据配置

	// 	icon: "typePng"
	// },


	{
		groupName: "content",
		isNeedData: true,
		level: 4,
		name: "文本",
		compoentName: "wmTextList", // 组件名称 
		designName: "wmTextListTool",
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		preStyle: {
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {
			link:{},
			textList: {
				subList: [],
				list: [{
						language: "zh_cn",
						languageName: "中文",
						text: "",
					},
					{
						language: "en",
						languageName: "英文",
						text: "",
					},
					{
						language: "zh_hk",
						languageName: "繁体中文",
						text: "",
					},
					{
						language: "ja",
						languageName: "Japanese",
						text: "",
					},
					{
						language: "ko",
						languageName: "간체 중문",
						text: "",
					},
					{
						language: "de",
						languageName: "Deutsch",
						text: "",
					},
					{
						language: "es",
						languageName: "Espanol",
						text: "",
					},
					{
						language: "fr",
						languageName: "French",
						text: "",
					},
					{
						language: "id",
						languageName: "Indonesia",
						text: "",
					},
					{
						language: "it",
						languageName: "Italiano",
						text: "",
					},
					{
						language: "ru",
						languageName: "Русский",
						text: "",
					}
				]
			}
		}, // 数据配置
		layoutConfig: {
			expandable:false,
			flex:"center", // 文字对齐 flex-start flex-end
			bg: {
				type: "1", // 1 纯色 2 渐变
				bgColor: "#000",
				gradientColor: "",
				
				bgImg: "", // 背景图片 3
				bgPosition: "", // 位置 3
				bgImgType: "",
				bgHeight: 0,
				bgWidth: 0
				
			},
			border: {
				borderRadius: [0, 0, 0, 0],
				borderSize: [0, 0, 0, 0],
				radius: 0,
				type: "solid",
				px: 0,
				color: "#fff"
			},
			padding: [0, 0, 0, 0],
			margin: [0, 0, 0, 0],
			
			titSize: 16, // 标题大小
			titColor: "#000000", // 标题颜色
			titBold: "none", // 标题粗细
			titFontFamily: '',
			titHoverColor: "",
			titMargin:[0,0,0,0],
			
			subTitSize: 16, // 标题大小
			subTitColor: "#000000", // 标题颜色
			subTitBold: "none", // 标题粗细
			subTitFontFamily: '',
			subHoverColor: "",
			subTitMargin:[0,0,0,0],
		},

		icon: "typePng"
	},
	
	
	
	{
		groupName: "content",
		isNeedData: true,
		level: 4,
		name: "代码编辑器",
		compoentName: "wmHtmlEditor", // 组件名称 
		designName: "wmHtmlEditorTool",
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		preStyle: {
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {
			code:""
		},
		icon: "typePng"
	},


	// {
	// 	groupName: "content",
	// 	isNeedData: true,
	// 	level: 4,
	// 	name: "轮播图",
	// 	compoentName: "wmCarousel", // 组件名称 
	// 	containerLayout: {
	// 		justify: "start",
	// 	},
	// 	style: {}, // style 配置
	// 	preStyle: {
	// 		// 组件样式实际上是容器样式
	// 		compontentStyle: {
	// 			width: 100,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			needHW: false,
	// 			needFont: false
	// 		},
	// 		compontentStylePhone: {
	// 			width: 100,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			needHW: false,
	// 			needFont: false
	// 		},
	// 		// 组件的样式
	// 	}, // 预编译style 配置
	// 	data: {
	// 		imgUrl: {
	// 			list: [{
	// 				url: ""
	// 			}]
	// 		},
	// 	}, // 数据配置
	// 	icon: "el-icon-edit"
	// },


	{
		groupName: "basic",
		level: 4,
		name: "空白",
		compoentName: "wmBank", // 组件名称
		designName: "wmBankTool",
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置

		preStyle: {
			selfStyle: {
				bg: {
					position: "top left",
					bgtype: "color", // color gradient img
					bgGradient: "",
					bgImgWidth: 0,
					bgImgHeigth: 0,
					img: "",
					type: "no-repeat",
					color: "",
				},

				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
			},
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 20,
				height: 20,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: true,
				needFont: false
			},
			compontentStylePhone: {
				width: 20,
				height: 20,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: true,
				needFont: false
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {}, // 数据配置

		icon: "maximizePng"
	},



	{
		groupName: "basic",
		level: 4,
		name: "导航",
		compoentName: "wmNavTwo", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		designName: "wmNavTool",
		preStyle: {
			selfStyle: {
				gap: 10,
				bg: {
					position: "top left",
					bgtype: "color", // color gradient img
					bgGradient: "",
					bgImgWidth: 0,
					bgImgHeigth: 0,
					img: "",
					type: "no-repeat",
					color: "",
				},
				padding: [0, 0, 0, 0],
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
			},
			font: {
				italic: false,
				size: 20,
				weight: "",
				color: "",
				background: {
					angle: 0,
					color1: "",
					color2: ""
				},
			},
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 700,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				hoverColor: "#635bff",
				needHW: false,
				needFont: true
			},
			compontentStylePhone: {
				width: 200,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				hoverColor: "#635bff",
				needHW: false,
				needFont: true
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {}, // 数据配置
		icon: "layoutAltPng",
		requestFun: ['mounteds'],
		requestData: {}
	},
	
	
	{
		groupName: "basic",
		level: 4,
		name: "订阅",
		compoentName: "wmAuthSendEmail", // 组件名称 
		style: {}, // style 配置
		containerLayout: {
			justify: "start",
		},
		designName: "wmAuthSendEmailTool",
		preStyle: {
			selfStyle: {
				iptType: "", // max / medium / small / mini 
				showBtn: true,
				showBtnIcon: true,
				showPreIcon: false,
				btnText: "",
				showInput: true,
				iptWidth: 300,
				btnFontColor: "#000000",
				bg: {
					position: "top left",
					bgtype: "color", // color gradient img
					bgGradient: "",
					bgImgWidth: 0,
					bgImgHeigth: 0,
					img: "",
					type: "no-repeat",
					color: "",
				},
				padding: [0, 0, 0, 0],
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				borderHover: {
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "",
					px: 0,
					color: "#fff"
				},
				icon: {
					iconName: "",
					show: true
				},
			},
			// 组件样式实际上是容器样式
			compontentStyle: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			compontentStylePhone: {
				width: 100,
				height: 400,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: true
			},
			// 组件的样式
		}, // 预编译style 配置
		data: {}, // 数据配置
		icon: "emailPng"
	},
	
	
	{
		groupName: "basic",
		level: 4,
		name: "留言",
		compoentName: "wmMessage", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {},
		icon: "lyPng",
		designName: "wmMessageTool",
		data: {
			classfiy: [],
		}, // 数据配置
		requestFun: ['mounteds'],
		preStyle: {
			compontentStyle: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			}
			// 默认组件样式实际上是容器样式
	
			// 组件的样式
		}, // 预编译style 配置
		layoutConfig: {
			isLabelBold:true,
			isBold:true,
			titleSize:16,
			titleFontFamily:"",
			tit:"",
			titColor:"#000",
			width:200,
			size:"",
			labelColor:"#000",
			labelFontSize:16,
			borIptColor:"#000",
			borIptHoverColor:"#55aaff",
			borIptDedaultColor:"#868686",
			titleMarTop:15,
			titMarBto:4,
			iptMarBto:14,
			sort:[{
				label:"姓名",
				value:'name'
			},
			{
				label:"邮箱",
				value:'email'
			},
			{
				label:"手机号码",
				value:'phone'
			},
			{
				label:"地址",
				value:'address'
			},
			{
				label:"内容",
				value:'content'
			}],
			email:{
				show:true,
				width:200,
				isRequire:true,
				size:"",
				labelColor:"#000"
			},
			name:{
				show:true,
				width:200,
				isRequire:true,
				size:"",
				labelColor:"#000"
			},
			phone:{
				show:true,
				width:200,
				isRequire:true,
				size:"",
				labelColor:"#000"
			},
			 address:{
				 show:true,
			 	width:200,
				isRequire:true,
				size:"",
				labelColor:"#000"
			 },
			 title:{
				 show:true,
			 	color:200,
				fontSize:16,
				isRequire:true,
			 },
			 content:{
				 show:true,
				title:"",
			 	width:200,
				isRequire:true,
				row:2
			 },
			 btn:{
				 size:"",
				 width:200,
				 fontColor:"#000",
				 hoverColor:"",
				 fontSize:16,
				 bg: {
				 	bgtype: "color", // color gradient
				 	bgGradient: "",
				 	color: "",
				 },
				 hoverBg: {
				 	bgtype: "color", // color gradient
				 	bgGradient: "",
				 	color: "",
				 },
				 border: {
				 	borderRadius: [0, 0, 0, 0],
				 	borderSize: [1,1,1,1],
				 	radius: 0,
				 	type: "solid",
				 	px: 0,
				 	color: "#000000"
				 },
			 }
			  
		},
		hidden: true, // 隐藏
		canDel: false, // 是否可以被删除
	},
	
	
	// {
	// 	groupName: "basic",
	// 	level: 4,
	// 	name: "页脚",
	// 	compoentName: "wmFooter", // 组件名称 
	// 	containerLayout: {
	// 		justify: "start",
	// 	},
	// 	style: {}, // style 配置
	// 	preStyle: {

	// 		compontentStyle: {
	// 			width: 700,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			hoverColor: "#635bff",
	// 			needHW: false,
	// 			needFont: true
	// 		},
	// 		compontentStylePhone: {
	// 			width: 200,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			hoverColor: "#635bff",
	// 			needHW: false,
	// 			needFont: true
	// 		},

	// 		// 组件的样式
	// 	}, // 预编译style 配置
	// 	data: {}, // 数据配置
	// 	icon: "el-icon-edit",
	// 	requestFun: ['mounteds'],
	// 	requestData: {
	// 		mounted: async (that) => {
	// 			// let wsid = that.$cookies.get("wsid")
	// 			// let data = await getDesignfooter({
	// 			// 	wsid
	// 			// })
	// 			// return {
	// 			// 	field: "footerData",
	// 			// 	data: data.data.data
	// 			// }
	// 		}
	// 	}
	// },
	// {
	// 	groupName: "goods",
	// 	isNeedData: true,
	// 	level: 4,
	// 	name: "商品模块",
	// 	compoentName: "wmGoods", // 组件名称 
	// 	containerLayout: {
	// 		justify: "start",
	// 	},
	// 	style: {}, // style 配置
	// 	preStyle: {
	// 		// 组件样式实际上是容器样式
	// 		compontentStyle: {
	// 			width: 100,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			hoverColor: "#635bff",
	// 			needHW: false,
	// 			needFont: true
	// 		},
	// 		compontentStylePhone: {
	// 			width: 100,
	// 			height: 400,
	// 			percentWidth: 100,
	// 			percentHeight: 100,
	// 			percentWidthSwitch: false,
	// 			percentHeightSwitch: true,
	// 			hoverColor: "#635bff",
	// 			needHW: false,
	// 			needFont: true
	// 		},

	// 		border: {
	// 			color: "#000000"
	// 		},
	// 		// 展示价格和名称
	// 		showNamePrice: false,
	// 		// 模块大小百分比
	// 		showModuleWidthHeightPre: true,
	// 		// 列表生效
	// 		moduleWidthHeightPre: 22,
	// 		// 模块大小
	// 		moduleWidthHeight: 100,
	// 		showTitle: false, // 隐藏标题
	// 		// 列表list 滑动scroll
	// 		moduleType: "list"
	// 		// 组件的样式
	// 	}, // 预编译style 配置
	// 	data: {
	// 		classfiy: [],
	// 	}, // 数据配置
	// 	requestFun: ['mounteds'],
	// 	requestData: {},
	// 	layoutConfig: {
	// 		goodsConfig: {
	// 			width: 400,
	// 			height: 250,
	// 			btn: {
	// 				// 按钮悬停显示
	// 				btnHoverShow: true,
	// 				// 按钮显示
	// 				btnShow: true,
	// 				bgColor: "#000",
	// 				rightBorderColor: "#fff",
	// 				addCartShow: true,
	// 				addCartColor: "#fff",
	// 				addCartFamily: "",
	// 				addCartSize: 16,
	// 				buyNowShow: true,
	// 				buyNowColor: "#fff",
	// 				buyNowFamily: "",
	// 				buyNowSize: 16,
	// 				likeShow: true,
	// 				likeColor: "#fff",
	// 				likeFamily: "",
	// 				likeSize: 16
	// 			},
	// 			// 悬停边框
	// 			hoverShadow: true,
	// 			hoverShadowColor: '#999',
	// 			pcNum: 4,
	// 			phoneNum: 2,
	// 			columnGap: 22,
	// 			rowGap: 22,
	// 			padding: [0, 0, 0, 0],
	// 			bg: {
	// 				type: "2",
	// 				// 纯色
	// 				color: "",
	// 				// 渐变
	// 				gradientColor: "background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%);"
	// 			},
	// 			border: {
	// 				borderRadius: [0, 0, 0, 0],
	// 				borderSize: [0, 0, 0, 0],
	// 				radius: 0,
	// 				type: "solid",
	// 				px: 0,
	// 				color: "#fff"
	// 			},
	// 			borderHover: {
	// 				borderSize: [0, 0, 0, 0],
	// 				radius: 0,
	// 				type: "solid",
	// 				px: 0,
	// 				color: "#fff"
	// 			},
	// 			font: {
	// 				hoverColor: "",
	// 				// 标题
	// 				titleShow: true,
	// 				titleSize: 14,
	// 				titleColor: "#000000",
	// 				titleFamily: "",
	// 				titleHoverColor: "",
	// 				// 折扣
	// 				discountShow: true,
	// 				discountPriceSize: 14,
	// 				discountPriceColor: "#000000",
	// 				discountPriceFamily: "",
	// 				discountPriceHoverColor: "",
	// 				// 原价
	// 				originalShow: true,
	// 				originalPriceSize: 14,
	// 				originalPriceColor: "#acacac",
	// 				originalPriceFamily: "",
	// 				originalPriceHoverColor: "",
	// 			}
	// 		}
	// 	},


	// 	icon: "shoppingBagPng",
	// },

	{
		groupName: "goods",
		level: 4,
		name: "商品详情",
		compoentName: "wmDetail", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		requestFun: ['mounteds'],
		preStyle: {

			compontentStyle: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			}

			// 默认组件样式实际上是容器样式

			// 组件的样式
		}, // 预编译style 配置
		data: {

		}, // 数据配置
		icon: "filePng",
		hidden: true, // 隐藏
		canDel: false, // 是否可以被删除
		// requestFun: ['mounteds'], // 预览或者前台访问重新数据装配 统一请求
		rightComponentTabs: [{
			title: '配置',
			name: 'wmDetailTab',
			type: "add"
		}],
		designToolName: "wmDetailTab",

		layoutConfig: {
			left: {
				borderRadius: [0, 0, 0, 0],
				borderSize: [0, 0, 0, 0],
				borderColor: "",
				borderType: "solid",
				borderAffiliatedRadius: [0, 0, 0, 0],
				borderAffiliatedSize: [0, 0, 0, 0],
				borderAffiliatedColor: "#000000",
				borderAffiliatedHoverColor: "#000000",
				borderAffiliatedType: "solid",
				width: 50,
				preViewListPosition: "left", // left 、top 、 bottom 、right
				preViewListImgWidth: 80,
				preViewListImgPhoneWidth: 40,
				preViewListImgHeight: 80,
				preViewListImgPhoneHeight: 40,
				preViewListHeight: 500,
				preViewImgWidth: 420,
				preViewImgPhoneWidth: 200,
				preViewImgPhoneHeight: 300,
				preViewImgHeight: 420,
				layout: "start",

				// 附属图边框悬停颜色
				borderAffiliatedHoverColor: "#000000",
				percentWidthSwitch: false, // 是否100% 填充  变成裁剪填充了
				percentWidthPhoneSwitch: false, // 是否手机端 100% 填充

				percentrAffiliateWidthSwitch: true, // 是否100% 填充  变成裁剪填充了

			},
			right: {
				marginLeft: 0,
				width: 50,
				titleSize: 18, // 标题大小
				titleColor: "#000000", // 标题颜色
				titleBold: "bold", // 标题粗细
				titlePosition: 'left',
				titleFontFamily: '',

				// 价格
				priceSize: 16, // 标题大小
				priceColor: "#000000", // 标题颜色
				priceBold: "none", // 标题粗细
				priceFontFamily: '',

				// 折扣价格
				discountSize: 14, // 标题大小
				discountColor: "#000000", // 标题颜色
				discountBold: "none", // 标题粗细
				discountFamily: '',

				// 产品选项
				optionSize: 14,
				optionColor: '#000000',
				optionFamily: '',
				optionBorderType: 'solid',
				optionBorderColor: '#000000',
				isHover: false,
				hoverColor: "",
				hoverBorderType: '',
				hoverBorderColor: '',
				optionBorderSize: [1, 1, 1, 1],
				optionBorderRadius: [1, 1, 1, 1],


				// 库存
				inventoryFamily: "",
				showInventory: true,
				InventorySize: 16, // 标题大小
				InventoryColor: "#000000", // 标题颜色

				// 品牌
				brandFamily: "",
				showBrand: true,
				brandSize: 16, // 标题大小
				brandColor: "#000000", // 标题颜色
				// SKU
				skuFamily: "",
				showSKU: true,
				skuSize: 16, // 标题大小
				skuColor: "#000000", // 标题颜色

				// 型号
				modelFamily: "",
				showSize: true,
				sSize: 16, // 标题大小
				sColor: "#000000", // 标题颜色

				// 规格
				specSize: 16, // 标题大小
				specsColor: "#000000", // 标题颜色
				specsBorder: "#000000", // 边框颜色


				// 按钮设置
				showAddNum: true,
				showAddCart: true,
				showBuyNow: true,
				showLove: true,

				// 产品详情
				showDetail: true,
				showAttr: true,
				showComment: true,
				detailModel: 'label', // label block accordion
				detailBorderType: "",
				detailBorderColor: "#000000",
				detailBorderSize: [1, 1, 1, 1]

			},
			bto: {
				widthType: "percentage", // percentage px
				width: 1000, //  widthType = px
				bgType: "1", // 1 纯色 2 渐变 3 背景图片
				singleBgColor: "", // 纯色
				bgColor: "", // 渐变 2
				type: "", // 类型 2
				bgImg: "", // 背景图片 3
				bgPosition: "", // 位置 3
				bgImgType: "",
				bgHeight: 0,
				bgWidth: 0

			}
		},
		// 过滤tab
		filter: ['2']
	},
	{
		groupName: "goods",
		level: 4,
		name: "商品模块",
		compoentName: "wmGoodsList", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {},
		icon: "shoppingBagPng",
		designName: "wmGoodsListTool",
		data: {
			classfiy: [],
		}, // 数据配置
		requestFun: ['mounteds'],
		preStyle: {
			compontentStyle: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			}
			// 默认组件样式实际上是容器样式

			// 组件的样式
		}, // 预编译style 配置
		layoutConfig: {
			type: "tab", // 类型 tab 类型 block 模块类型 list
			followClassfiy: false,
			selectColor: "#000",
			noSelectColor: "#b4b4b4",
			titleFamily: "",
			hoverColor: "",
			titleSize: 16,
			reload: false,
			setDesignItem: "",
			goodsConfig: {
				width: 250,
				height: 250,
				phoneWidth: 250,
				phoneHeight: 250,
				btn: {
					position: '1',
					// 按钮悬停显示
					btnHoverShow: true,
					// 按钮显示
					btnShow: true,

					// 加入购物车显示
					addCartBtnShow: true,
					// 立即购买显示
					buyNowBtnShow: true,
					// 立即购买显示
					likeBtnShow: true,
					
					addCartBtnBg: {
						type: "1", // 1 纯色 2 渐变
						bgColor: "#000",
						gradientColor: ""
					},
					buyNowBtnBg: {
						type: "1", // 1 纯色 2 渐变
						bgColor: "#000",
						gradientColor: ""
					},
					likeBtnBg: {
						type: "1", // 1 纯色 2 渐变
						bgColor: "#000",
						gradientColor: ""
					},
					bgColor: "#000",
					rightBorderColor: "#fff",
					addCartShow: true,
					addCartColor: "#fff",
					addCartFamily: "",
					addCartSize: 16,
					buyNowShow: true,
					buyNowColor: "#fff",
					buyNowFamily: "",
					buyNowSize: 16,
					likeShow: true,
					likeColor: "#fff",
					likeFamily: "",
					likeSize: 16
				},
				// 悬停边框
				hoverShadow: true,
				hoverShadowColor: '#999',
				pcNum: 4,
				phoneNum: 2,
				columnGap: 22,
				rowGap: 22,

				phoneColumnGap: 14,
				phoneRowGap: 14,

				padding: [0, 0, 0, 0],
				bg: {
					type: "1",
					// 纯色
					color: "",
					// 渐变
					gradientColor: "background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%);"
				},
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				borderHover: {
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				font: {
					hoverColor: "",
					// 标题
					titleShow: true,
					titleSize: 14,
					titleColor: "#000000",
					titleFamily: "",
					titleHoverColor: "",
					// 折扣
					discountShow: true,
					discountPriceSize: 14,
					discountPriceColor: "#000000",
					discountPriceFamily: "",
					discountPriceHoverColor: "",
					// 原价
					originalShow: true,
					originalPriceSize: 14,
					originalPriceColor: "#acacac",
					originalPriceFamily: "",
					originalPriceHoverColor: "",
				}
			}
		},
		hidden: true, // 隐藏
		canDel: false, // 是否可以被删除
	},

	{
		groupName: "goods",
		level: 4,
		name: "商品分类",
		compoentName: "wmClassify", // 组件名称 
		containerLayout: {
			justify: "start",
		},
		style: {}, // style 配置
		// requestFun: ['mounteds'],
		preStyle: {
			compontentStyle: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			},
			compontentStylePhone: {
				width: 30,
				height: 30,
				percentWidth: 100,
				percentHeight: 100,
				percentWidthSwitch: false,
				percentHeightSwitch: true,
				needHW: false,
				needFont: false
			}
			// 默认组件样式实际上是容器样式

			// 组件的样式
		}, // 预编译style 配置
		data: {}, // 数据配置
		icon: "filePng",
		hidden: true, // 隐藏
		canDel: false, // 是否可以被删除
		designName: "wmClassifyTool",
		layoutConfig: {
			classFiyConfig: {
				// 标题颜色
				titleColor: "#000",
				// 价格滑块颜色
				priceSliderColor: "#635bff",
				paginationSelectColor: "#55aaff",
				paginationHoverColor: "#55aaff",
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				left: {
					show: true
				},
				font: {
					classFiySelectdColor: "#635bff",
					classFiySzie: 15,
					classFiyColor: "#000",
					classFiySzieFamily: "",
				}
			},
			goodsConfig: {
				width: 250,
				height: 250,
				phoneWidth: 250,
				phoneHeight: 250,
				btn: {
					position: '1',
					// 按钮悬停显示
					btnHoverShow: true,
					// 按钮显示
					btnShow: true,

					// 加入购物车显示
					addCartBtnShow: true,
					// 立即购买显示
					buyNowBtnShow: true,
					// 立即购买显示
					likeBtnShow: true,

					addCartBtnBg: {
						type: "1", // 1 纯色 2 渐变
						bgColor: "#000",
						gradientColor: ""
					},
					buyNowBtnBg: {
						type: "1", // 1 纯色 2 渐变
						bgColor: "#000",
						gradientColor: ""
					},
					likeBtnBg: {
						type: "1", // 1 纯色 2 渐变
						bgColor: "#000",
						gradientColor: ""
					},

					bgColor: "#000",
					rightBorderColor: "#fff",
					addCartShow: true,
					addCartColor: "#fff",
					addCartFamily: "",
					addCartSize: 16,
					buyNowShow: true,
					buyNowColor: "#fff",
					buyNowFamily: "",
					buyNowSize: 16,
					likeShow: true,
					likeColor: "#fff",
					likeFamily: "",
					likeSize: 16
				},
				// 悬停边框
				hoverShadow: true,
				hoverShadowColor: '#999',
				pcNum: 4,
				phoneNum: 2,
				columnGap: 22,
				rowGap: 22,

				phoneColumnGap: 14,
				phoneRowGap: 14,

				padding: [0, 0, 0, 0],
				bg: {
					type: "1",
					// 纯色
					color: "",
					// 渐变
					gradientColor: "background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%);"
				},
				border: {
					borderRadius: [0, 0, 0, 0],
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				borderHover: {
					borderSize: [0, 0, 0, 0],
					radius: 0,
					type: "solid",
					px: 0,
					color: "#fff"
				},
				font: {
					hoverColor: "",
					// 标题
					titleShow: true,
					titleSize: 14,
					titleColor: "#000000",
					titleFamily: "",
					titleHoverColor: "",
					// 折扣
					discountShow: true,
					discountPriceSize: 14,
					discountPriceColor: "#000000",
					discountPriceFamily: "",
					discountPriceHoverColor: "",
					// 原价
					originalShow: true,
					originalPriceSize: 14,
					originalPriceColor: "#acacac",
					originalPriceFamily: "",
					originalPriceHoverColor: "",
				}
			}
		},
	},
]
export default compoentsConfig